<template>
  <component :is="component">
    <div v-if="isBoolean(getValue)" class="ui read-only toggle checkbox">
      <input type="checkbox" :checked="value" @click.stop.prevent="void 0">
      <label></label>
    </div>
    <template v-else>
      {{getValue}}
    </template>
  </component>
</template>

<script>
  import {isObject,isInteger,isNumber,isBoolean} from 'lodash'
  import {numberFormat} from '@/utils/commonUtils'
  export default {
    name: "simple-value-view",
    props:{
      component:{
        type:[String],
        default:"span"
      },
      value:{
        type:[String,Number,Boolean,Object],
      },
      defaultValue:{
        type:[String,Number,Boolean,Object],
        default:undefined//если не указать то defaultValue будет значение false
      },
      emptyHolder:{
        type:[String],
        default:""
      },
      dateTimeFormat:{
        type:[String],
      },
      durationFormat:{
        type:[String],
      },
      numberFormat:{
        type:Object,
        default:()=>{
          return{
            lenghtOfDecimal:5,
            lenghtOfWholePart:0,
            sectionDelimiter:",",
            decimalDelimiter:"."
          }
        }
      },
      titleProp:{
        type:[String],
        default:"label"
      }
    },
    computed:{
      getValue(){
        let value = this.value!=null?this.value:this.defaultValue;
        if (value==null) return this.emptyHolder;
        if (isObject(value)) value = value[this.titleProp];

        if (this.durationFormat) return this.$moment.duration(value,"milliseconds").format(this.durationFormat);

        if (this.dateTimeFormat) return this.$moment(value).format(this.dateTimeFormat);

        if (isNumber(value)&&!isInteger(value)) return +value.toFixed(this.numberFormat.lenghtOfDecimal); //numberFormat(value,this.numberFormat.lenghtOfDecimal,this.numberFormat.lenghtOfWholePart,this.numberFormat.sectionDelimiter,this.numberFormat.decimalDelimiter)

        return value;
      }
    },
    methods:{
      isBoolean
    }
  }
</script>

<style scoped>

</style>
